// Mock data for Sanmiggrc Technologies Regulatory Compliance Platform

export const mockUser = {
  name: "Sanjeev Bhardwaj",
  role: "Founder & CEO",
  company: "Sanmiggrc Technologies Private Limited",
  email: "sanjeev@sanmiggrc.com",
  avatar: "SB"
};

export const mockMetrics = {
  complianceScore: { value: "98.5%", change: "+2.1%" },
  activeRegulations: { value: 47, change: "+5" },
  aiAgentsActive: { value: 185, change: "100%" },
  regulatoryAlerts: { value: 7, change: "+2" },
  amlAlerts: { value: 23, change: "+8" },
  activeAudits: { value: 12, change: "+3" },
  sanctionsScreened: { value: "1.2M", change: "+15%" },
  transactionsMonitored: { value: "3.4M", change: "+22%" },
  leadsInbound: { value: 342, change: "+28" },
  redFlaggedAccounts: { value: 156, change: "+12" }
};

export const mockRegulatoryModules = [
  {
    id: 1,
    regulator: "RBI",
    module: "CMS IT Framework",
    compliance: 96,
    lastAudit: "2026-03-15",
    nextReview: "2026-06-15",
    status: "compliant",
    findings: 2,
    criticalGaps: 0
  },
  {
    id: 2,
    regulator: "FIU-IND",
    module: "VDASPs Compliance",
    compliance: 94,
    lastAudit: "2026-02-20",
    nextReview: "2026-05-20",
    status: "compliant",
    findings: 3,
    criticalGaps: 0
  },
  {
    id: 3,
    regulator: "MeitY",
    module: "DPDP Act 2026",
    compliance: 88,
    lastAudit: "2026-04-10",
    nextReview: "2026-11-01",
    status: "in-progress",
    findings: 5,
    criticalGaps: 1
  },
  {
    id: 4,
    regulator: "I4C",
    module: "CIMS Integration",
    compliance: 92,
    lastAudit: "2026-03-25",
    nextReview: "2026-06-25",
    status: "compliant",
    findings: 4,
    criticalGaps: 0
  }
];

export const mockAMLAlerts = [
  {
    id: 1,
    alertId: "AML-2026-001234",
    type: "Behavioral Anomaly",
    severity: "high",
    customer: "Account #4567890123",
    amount: "₹2,45,000",
    description: "Multiple high-value transactions in short time window",
    timestamp: "2026-04-26 14:23:45",
    status: "under-review",
    assignee: "AML Team A",
    riskScore: 87
  },
  {
    id: 2,
    alertId: "AML-2026-001235",
    type: "Mule Account Detection",
    severity: "critical",
    customer: "Account #7890123456",
    amount: "₹8,90,000",
    description: "Suspected mule account - rapid in/out flow pattern detected",
    timestamp: "2026-04-26 13:15:22",
    status: "escalated",
    assignee: "Senior Analyst",
    riskScore: 94
  },
  {
    id: 3,
    alertId: "AML-2026-001236",
    type: "Sanctions Screening",
    severity: "critical",
    customer: "Beneficiary: XYZ Trading LLC",
    amount: "$15,000",
    description: "Beneficiary name matches OFAC SDN list",
    timestamp: "2026-04-26 12:45:10",
    status: "blocked",
    assignee: "Compliance Officer",
    riskScore: 98
  },
  {
    id: 4,
    alertId: "AML-2026-001237",
    type: "Device Anomaly",
    severity: "medium",
    customer: "User ID: USR789456",
    amount: "₹45,000",
    description: "New device login from high-risk geography",
    timestamp: "2026-04-26 11:30:55",
    status: "investigating",
    assignee: "Fraud Team",
    riskScore: 72
  },
  {
    id: 5,
    alertId: "AML-2026-001238",
    type: "Transaction Pattern",
    severity: "high",
    customer: "Account #3456789012",
    amount: "₹5,67,000",
    description: "Structuring detected - multiple transactions below reporting threshold",
    timestamp: "2026-04-26 10:15:30",
    status: "under-review",
    assignee: "AML Team B",
    riskScore: 85
  }
];

export const mockTransactionMonitoring = {
  totalMonitored: "3.4M",
  flaggedTransactions: 1245,
  blockedTransactions: 89,
  falsePositives: 234,
  truePositives: 67,
  avgProcessingTime: "2.3s",
  realTimeAlerts: 23,
  batchAlerts: 145
};

export const mockAIGovernance = [
  {
    id: 1,
    module: "Model Risk Management",
    status: "deployed",
    coverage: 95,
    lastReview: "2026-04-15",
    aiModels: 23,
    validated: 22,
    inProduction: 20
  },
  {
    id: 2,
    module: "Bias Detection & Mitigation",
    status: "active",
    coverage: 88,
    lastReview: "2026-04-10",
    aiModels: 23,
    validated: 20,
    inProduction: 18
  },
  {
    id: 3,
    module: "Explainability Framework",
    status: "active",
    coverage: 82,
    lastReview: "2026-04-05",
    aiModels: 23,
    validated: 19,
    inProduction: 16
  },
  {
    id: 4,
    module: "Model Monitoring & Drift Detection",
    status: "deployed",
    coverage: 92,
    lastReview: "2026-04-20",
    aiModels: 23,
    validated: 21,
    inProduction: 19
  }
];

export const mockAIAgents = [
  { id: 1, name: "Compliance Monitor", status: "active", tasks: 23, category: "compliance" },
  { id: 2, name: "AML Screener", status: "active", tasks: 156, category: "aml" },
  { id: 3, name: "Sanctions Checker", status: "active", tasks: 89, category: "sanctions" },
  { id: 4, name: "Behavioral Analyzer", status: "active", tasks: 234, category: "behavioral" },
  { id: 5, name: "Device Fingerprinter", status: "active", tasks: 178, category: "device" },
  { id: 6, name: "Mule Detector", status: "active", tasks: 67, category: "fraud" },
  { id: 7, name: "Transaction Monitor", status: "active", tasks: 345, category: "monitoring" },
  { id: 8, name: "Regulatory Reporter", status: "active", tasks: 28, category: "reporting" },
  { id: 9, name: "Risk Scorer", status: "active", tasks: 456, category: "risk" },
  { id: 10, name: "Alert Prioritizer", status: "active", tasks: 234, category: "triage" }
];

export const mockLeads = [
  {
    id: 1,
    source: "LinkedIn",
    name: "FinTech Innovations Pvt Ltd",
    contact: "Rahul Sharma",
    email: "rahul@fintechinnovations.com",
    status: "new",
    priority: "high",
    service: "RBI CMS IT Compliance",
    date: "2026-04-20"
  },
  {
    id: 2,
    source: "Website",
    name: "Crypto Exchange India",
    contact: "Priya Gupta",
    email: "priya@cryptoexchange.in",
    status: "contacted",
    priority: "high",
    service: "FIU VDASPs Compliance",
    date: "2026-04-19"
  },
  {
    id: 3,
    source: "Email Query",
    name: "Digital Payments Corp",
    contact: "Amit Patel",
    email: "amit@digitalpay.com",
    status: "qualified",
    priority: "medium",
    service: "AML Transaction Monitoring",
    date: "2026-04-18"
  },
  {
    id: 4,
    source: "Meeting Booked",
    name: "E-Commerce Platform Ltd",
    contact: "Suresh Kumar",
    email: "suresh@ecommplatform.com",
    status: "meeting-scheduled",
    priority: "medium",
    service: "DPDP Act Compliance",
    date: "2026-04-21"
  },
  {
    id: 5,
    source: "Mobile App",
    name: "AI Startup Solutions",
    contact: "Neha Reddy",
    email: "neha@aistartup.com",
    status: "new",
    priority: "high",
    service: "AI Governance Framework",
    date: "2026-04-20"
  }
];

export const mockAudits = [
  {
    id: 1,
    client: "National Digital Bank",
    type: "RBI CMS IT Audit",
    status: "in-progress",
    progress: 65,
    startDate: "2026-03-15",
    endDate: "2026-05-15",
    lead: "Sanjeev Bhardwaj",
    scope: "Cybersecurity Framework Assessment"
  },
  {
    id: 2,
    client: "Crypto VDASP Exchange",
    type: "FIU-IND Compliance Audit",
    status: "planning",
    progress: 20,
    startDate: "2026-04-22",
    endDate: "2026-06-22",
    lead: "Priya Sharma",
    scope: "AML/CFT Controls Review"
  },
  {
    id: 3,
    client: "E-Commerce Giant",
    type: "DPDP Act Readiness Audit",
    status: "in-progress",
    progress: 45,
    startDate: "2026-04-01",
    endDate: "2026-10-31",
    lead: "Compliance Team",
    scope: "Data Protection Framework"
  }
];

export const mockTeamMembers = [
  {
    id: 1,
    name: "Sanjeev Bhardwaj",
    role: "Chief Compliance Officer",
    initials: "SB",
    workload: 92,
    completed: 14,
    pending: 3,
    overdue: 1,
    specialization: "RBI & SEBI Regulations"
  },
  {
    id: 2,
    name: "Nisha Kapoor",
    role: "AML Compliance Manager",
    initials: "NK",
    workload: 95,
    completed: 18,
    pending: 2,
    overdue: 0,
    specialization: "AML/CFT & Transaction Monitoring"
  },
  {
    id: 3,
    name: "Rahul Joshi",
    role: "Cybersecurity Analyst",
    initials: "RJ",
    workload: 72,
    completed: 9,
    pending: 4,
    overdue: 2,
    specialization: "RBI CMS IT Framework"
  },
  {
    id: 4,
    name: "Sneha Patil",
    role: "Data Protection Officer",
    initials: "SP",
    workload: 96,
    completed: 22,
    pending: 1,
    overdue: 0,
    specialization: "DPDP Act & Privacy"
  },
  {
    id: 5,
    name: "Amit Desai",
    role: "AI Governance Specialist",
    initials: "AD",
    workload: 78,
    completed: 7,
    pending: 3,
    overdue: 1,
    specialization: "AI/ML Model Governance"
  }
];

export const mockNews = [
  {
    id: 1,
    title: "RBI Issues Enhanced Guidelines for CMS IT Framework 2.0",
    source: "Reserve Bank of India",
    time: "Just now",
    category: "RBI",
    url: "#"
  },
  {
    id: 2,
    title: "FIU-IND Releases New KYC Norms for VDASPs",
    source: "Financial Intelligence Unit",
    time: "2 hours ago",
    category: "FIU",
    url: "#"
  },
  {
    id: 3,
    title: "MeitY Announces DPDP Act Implementation Timeline - Nov 2026",
    source: "Ministry of Electronics & IT",
    time: "5 hours ago",
    category: "MeitY",
    url: "#"
  },
  {
    id: 4,
    title: "I4C Launches CIMS 2.0 for Cybercrime Investigation",
    source: "Indian Cybercrime Coordination Centre",
    time: "1 day ago",
    category: "I4C",
    url: "#"
  },
  {
    id: 5,
    title: "FATF Updates AML-CFT Standards for Digital Assets",
    source: "Financial Action Task Force",
    time: "2 days ago",
    category: "FATF",
    url: "#"
  }
];

export const mockSanctionsScreening = {
  totalScreened: "1.2M",
  matches: 234,
  falsePositives: 189,
  truePositives: 45,
  blocked: 45,
  avgResponseTime: "0.8s",
  listsMonitored: ["OFAC SDN", "UN Sanctions", "EU Sanctions", "UNSC", "HMT"]
};

export const mockDeviceMonitoring = {
  devicesTracked: "45.6K",
  suspiciousDevices: 234,
  blockedDevices: 89,
  newDeviceAlerts: 156,
  locationAnomalies: 67,
  vpnDetected: 234
};

// Legacy stubs — kept as empty arrays so old CA components still compile during the
// regulatory pivot. These will be removed once those components are deleted/refactored.
export const mockMeetings = [];
export const mockTasks = [];
export const mockCommunications = [];
export const mockComplianceItems = [];
